export const PERSIST_PROCESS_STATEMENT_QUESTIONS_FAILURE = 'PERSIST_PROCESS_STATEMENT_QUESTIONS_FAILURE';

export const persistProcessStatementQuestionsFailure = error => ({
    type: PERSIST_PROCESS_STATEMENT_QUESTIONS_FAILURE,
    payload: error,
    error: true,
});
